import { render, staticRenderFns } from "./BoundMobile.vue?vue&type=template&id=1da7d546&scoped=true&"
import script from "./BoundMobile.vue?vue&type=script&lang=js&"
export * from "./BoundMobile.vue?vue&type=script&lang=js&"
import style0 from "./BoundMobile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BoundMobile.vue?vue&type=style&index=1&id=1da7d546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da7d546",
  null
  
)

/* custom blocks */
import block0 from "./BoundMobile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports